import { Form, FormControls, useFormModel } from '@acme/foundation';
import { Button } from 'flowbite-react';
import { useMemo } from 'react';
import {
  counterpartyOfferFormConfig,
  type CounterpartyOfferFormData,
} from './model';

export type { CounterpartyOfferFormData } from './model';

export type CounterpartyOfferFormProps = {
  onConfirm: (data: CounterpartyOfferFormData) => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
  inline?: boolean;
};

export const initialCounterpartyOfferCtx: CounterpartyOfferFormData = {
  commissionAuthorizedOrganizationRUB: '',
  files: [],
};

export const ApplicationCounterpartyOfferForm = ({
  onConfirm,
  onCancel,
  isSubmitting = false,
  inline = false,
}: CounterpartyOfferFormProps) => {
  const config = useMemo(() => counterpartyOfferFormConfig(), []);
  const form = useFormModel<CounterpartyOfferFormData>({
    config,
    ctx: initialCounterpartyOfferCtx,
  });

  const commission = form.state.values.commissionAuthorizedOrganizationRUB;
  const commissionNum =
    typeof commission === 'number'
      ? commission
      : commission !== ''
        ? Number(commission)
        : NaN;
  const canSubmit =
    !isSubmitting &&
    !form.state.isSubmitting &&
    Number.isFinite(commissionNum) &&
    commissionNum > 0;

  return (
    <Form<CounterpartyOfferFormData>
      form={form}
      onSubmit={onConfirm}
      className="space-y-6"
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Предложение о сделке
      </h3>

      <div
        className={
          inline ? 'grid grid-cols-1 sm:grid-cols-2 gap-4' : 'space-y-4'
        }
      >
        <FormControls
          form={form}
          filter={(cfg) => cfg.id === 'commissionAuthorizedOrganizationRUB'}
        />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-normal text-gray-500">
          Загрузите необходимые документы сделки
        </p>
        <FormControls form={form} filter={(cfg) => cfg.id === 'files'} />
      </div>

      <div className="flex justify-end border-t border-gray-200 pt-4">
        <Button type="submit" color="primary" disabled={!canSubmit}>
          {isSubmitting || form.state.isSubmitting
            ? 'Отправка...'
            : 'Отправить предложение'}
        </Button>
        {!inline && onCancel ? (
          <Button
            type="button"
            color="light"
            onClick={onCancel}
            className="ml-2"
          >
            Отмена
          </Button>
        ) : null}
      </div>
    </Form>
  );
};
